var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, CustomElement, Event, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './PlotterInfoPopup.style';
import { IconRef } from '@sick-davinci/basic-elements';
import { icon_close } from '@sick-davinci/material-icons/navigation/close.icon.js';
import { ICON_ARROW_ALL_DIRECTIONS, ICON_DOUBLE_TAP, ICON_MAGNIFIER_DIAGONAL, ICON_MAGNIFIER_HORIZONTAL, ICON_MAGNIFIER_VERTICAL, ICON_MOUSE_LEFT_BUTTON, ICON_MOUSE_WHEEL, ICON_PAN, ICON_PINCH, ICON_RESET } from './PlotterIcons.js';
/**
 * A popup with information about the interaction with mouse or touch.
 *
 * @ignore
 *
 * This custom element is for internal use only.
 */

export let PlotterInfoPopup = (_dec = Component({
  tag: 'davinci-plotter-info-popup',
  style,
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Event(), _dec5 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class PlotterInfoPopup extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "touch", _descriptor, this);

    _initializerDefineProperty(this, "close", _descriptor2, this);

    _defineProperty(this, "_onBodyKeyDown", event => {
      switch (event.key) {
        case 'Enter':
        case 'Escape':
        case 'Delete':
          this._close();

          break;

        default:
          break;
      }
    });

    _defineProperty(this, "_onBodyPointerDown", event => {
      var _this$shadowRoot;

      const path = event.composedPath();
      const popup = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('.popup');
      const clickedOnPopup = path.findIndex(target => target === popup) !== -1;

      if (!clickedOnPopup) {
        this._close();
      }
    });
  }

  _close() {
    this.close.emit(this);
  }

  /** @override */
  componentConnected() {
    super.componentConnected();
    document.body.addEventListener('keydown', this._onBodyKeyDown);
    document.body.addEventListener('pointerdown', this._onBodyPointerDown);
  }
  /** @override */


  componentDisconnected() {
    super.componentDisconnected();
    document.body.removeEventListener('keydown', this._onBodyKeyDown);
    document.body.removeEventListener('pointerdown', this._onBodyPointerDown);
  }
  /** @override */


  componentDidRender() {
    var _this$shadowRoot2;

    super.componentDidRender(); // request focus for the close-button

    const closeButton = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById('closeButton');

    if (closeButton) {
      closeButton.focus();
    }
  }
  /** @override */


  render() {
    return html`
      <div class="popup" ?touch="${this.touch}">
        ${this._renderCloseButton()}
        ${this.touch ? this._renderForTouch() : this._renderForMouse()}
      </div>
    `;
  }

  _renderForTouch() {
    return html`
      <div class="popupContent">
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_MAGNIFIER_DIAGONAL}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_ARROW_ALL_DIRECTIONS}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_RESET}"></davinci-icon-ref>

        <davinci-icon-ref class="popupIcon" style="width: 2.75rem; height: 3.25rem;" .src="${ICON_PINCH}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon" style="width: 2.25rem; height: 3.25rem;" .src="${ICON_PAN}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon" style="width: 2.25rem; height: 3.25rem;" .src="${ICON_DOUBLE_TAP}"></davinci-icon-ref>
      </div>
    `;
  }

  _renderForMouse() {
    return html`
      <div class="popupContent">
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_MAGNIFIER_VERTICAL}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_MAGNIFIER_HORIZONTAL}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_ARROW_ALL_DIRECTIONS}"></davinci-icon-ref>
        <davinci-icon-ref class="popupIcon actionIcon" .src="${ICON_RESET}"></davinci-icon-ref>

        <davinci-icon-ref class="mouseIcon popupIcon" .src="${ICON_MOUSE_WHEEL}"></davinci-icon-ref>
        <davinci-icon-ref class="mouseIcon popupIcon" .src="${ICON_MOUSE_WHEEL}"></davinci-icon-ref>
        <davinci-icon-ref class="mouseIcon popupIcon" .src="${ICON_MOUSE_LEFT_BUTTON}"></davinci-icon-ref>
        <davinci-icon-ref class="mouseIcon popupIcon" .src="${ICON_MOUSE_LEFT_BUTTON}"></davinci-icon-ref>

        <span class="mouseActionText">[shift]</span>
        <span class="mouseActionText">[ctrl]</span>
        <span class="mouseActionText">&nbsp;</span>
        <span class="mouseActionText">2x</span>
      </div>
    `;
  }

  _renderCloseButton() {
    return html`
      <button class="closeButton" id="closeButton" @click="${this._close}">
        <davinci-icon-ref .src="${icon_close}" class="closeIcon"></davinci-icon-ref>
      </button>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "touch", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "close", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
